import {
  DocumentListCard,
  SkeletonDots,
  Unifree
} from '@yes.technology/react-toolkit'
import { NestedRelationCardViewProps } from './NestedRelationCard.types'
import SectionDivider from 'site/Renderer/components/SectionDivider/SectionDivider'
import { useTranslation } from 'react-i18n-lite'

const NestedRelationCardView = ({
  data,
  isNested = false,
  id,
  title,
  navigationSliderBackgroundColor,
  navigationSliderColor,
  isLoading
}: NestedRelationCardViewProps) => {
  const { t } = useTranslation()

  const content = (
    <div
      className={`${!isNested && 'p-2 '}row align-items-end g-1 justify-content-center`}
    >
      {isLoading && <SkeletonDots aria-label={t('system.loading')} />}
      {!isLoading && data.length === 0 && t('data-tables.no-records-found')}
      {!isLoading &&
        data.map(({ label, value }, key) => (
          <div key={key}>
            {typeof value === 'string' ? (
              <Unifree
                disabled
                label={label}
                value={value}
                required
                informational
                enableValueFading
              />
            ) : (
              <NestedRelationCardView data={value} isNested />
            )}
          </div>
        ))}
    </div>
  )

  return isNested ? (
    <DocumentListCard className='p-2' data-testid='nested-card-border'>
      {content}
    </DocumentListCard>
  ) : (
    <SectionDivider
      id={id}
      title={title}
      isCollapsibleCard={false}
      backgroundColor={navigationSliderBackgroundColor}
      color={navigationSliderColor}
      isVisible
    >
      {content}
    </SectionDivider>
  )
}

export default NestedRelationCardView
